import { get as getFace } from '@/api/gabed/face';
import { get as getMateriel } from '@/api/gabed/materiel';
import { get as getDispositif, getAll as getAllDispositif } from '@/api/gabed/dispositif';
import getLogo from '@/services/general/getLogo';
import { NO_PAGINATION } from '@/configuration/clientTableConf';

async function getLogoFace(id) {
  const face = (await getFace(id)).data.result;
  const logo = await getLogo(face.produitId);
  return logo;
}

async function getLogoMateriel(id) {
  let logo = await getLogo(id);
  if (!logo) {
    const materiel = (await getMateriel(id)).data.result;
    if (!materiel.faces || materiel.faces.length === 0) return logo;
    logo = await getLogoFace(materiel.faces[0].id);
  }
  return logo;
}

async function getLogoDispositif(id) {
  let logo = await getLogo(id);
  if (!logo) {
    const dispositif = (await getDispositif(id)).data.result;
    if (!dispositif.materiels || dispositif.materiels.length === 0) return logo;
    logo = await getLogoMateriel(dispositif.materiels[0].id);
  }
  return logo;
}

async function getLogoEmplacement(id, societeId) {
  let logo = await getLogo(id);
  if (!logo) {
    const dispositifs = (await getAllDispositif({
      query: {
        emplacementId: id,
        societeId: societeId,
      },
      limit: NO_PAGINATION,
    })).data.result.items;
    if (dispositifs.length === 0) return logo;
    logo = await getLogoDispositif(dispositifs[0].id);
  }
  return logo;
}

export default async function getLogoFromPatrimoine(otPatrimoine, societeId) {
  let logo = null;
  if (otPatrimoine.emplacementId) {
    logo = await getLogoEmplacement(otPatrimoine.emplacementId, societeId);
  } else if (otPatrimoine.dispositifId) logo = await getLogoDispositif(otPatrimoine.dispositifId);
  else if (otPatrimoine.materielId) logo = await getLogoMateriel(otPatrimoine.materielId);
  else if (otPatrimoine.faceId) logo = await getLogoFace(otPatrimoine.faceId);
  return logo;
}
